/**
 * THE GUIDES REGISTRY. One entry per guide; a guide's content is loaded only when
 * it is opened or searched. `load: null, route` is a guide that has its own page
 * ("How to use Track", views/guide.js) until it is ported to a guide.json.
 * Adding a guide: docs/regs-reference/GUIDE-SCHEMA.md and Help › Guides.
 */
export const GUIDES = [
  {
    id: 'how-to-use-track',
    title: 'How to use Track',
    line: 'What arrives, what it becomes, who decides and where the money goes.',
    kind: 'training',
    for: 'Everyone',
    minutes: 12,
    asOf: '2026-11-03',
    load: null,
    route: 'guide',
  },
  {
    id: 'building-regulations',
    title: 'Building Regulations',
    line: 'Every Part A–T, the thresholds, who owns what at ASP, dated changes to 2029.',
    kind: 'reference',
    for: 'Engineers',
    minutes: 25,
    asOf: '2026-11-03',
    sections: 23,
    load: () => import('./building-regulations.js'),
  },
  {
    id: 'suds-manual',
    title: 'The SuDS Manual',
    line: 'CIRIA C753: the four pillars, the management train, the design criteria, the components, what the LLFA signs.',
    kind: 'reference',
    for: 'Civil engineers',
    minutes: 25,
    asOf: '2026-11-03',
    sections: 13,
    load: () => import('./suds-manual.js'),
  },
  {
    id: 'party-wall-act',
    title: 'The Party Wall Act',
    line: 'The Party Wall etc. Act 1996: which walls, the three notices, the 3 m and 6 m tests, the award, what the engineer provides.',
    kind: 'reference',
    for: 'Engineers and coordinators',
    minutes: 20,
    asOf: '2026-11-03',
    sections: 9,
    load: () => import('./party-wall-act.js'),
  },
  {
    id: 'planning-pd',
    title: 'Planning and permitted development',
    line: 'Which consent a project needs, the GPDO classes and their numbers, prior approval, the application, LDCs and enforcement, and what the engineer provides.',
    kind: 'reference',
    for: 'Everyone',
    minutes: 25,
    asOf: '2026-11-04',
    sections: 15,
    load: () => import('./planning-pd.js'),
  },
];

/** Every guide that has content, loaded. */
export async function loadGuides() {
  const mods = await Promise.all(GUIDES.filter((g) => g.load).map((g) => g.load()));
  return mods.map((m) => m.GUIDE);
}
